/**
 * One-time cleanup script to remove all cache entries from localStorage
 */
export function cleanupLocalStorageCache() {
  console.log('🧹 Cleaning up localStorage cache entries...');
  
  const keysToRemove: string[] = [];
  
  // Find all cache keys
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith('cache_')) {
      keysToRemove.push(key);
    }
  }
  
  // Remove all cache keys
  keysToRemove.forEach(key => {
    console.log(`Removing cache key: ${key}`);
    localStorage.removeItem(key);
  });
  
  if (keysToRemove.length > 0) {
    console.log(`✅ Cleaned up ${keysToRemove.length} cache entries from localStorage`);
  } else {
    console.log('✅ No cache entries found in localStorage');
  }
}

// Run cleanup immediately
if (typeof window !== 'undefined') {
  cleanupLocalStorageCache();
}